import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import { errorMessage } from '../../constants/errorMessage'
import { Circles } from 'react-loader-spinner'

const DefaultComponent = () => <></>
function PGIframeDC(props) {
    const { isSubmittingForm, onSubmit, faciltyData, consent, page, previousButton, setFormData, formData, setValue, APILoad } = props

    const [divChilds, setDivChilds] = useState(0)
    const [gatewayError, setGatewayError] = useState('')

    useEffect(() => {
        const restrictedDiv = document.getElementById('token-iframe')
        const childCount = restrictedDiv?.children?.length
        setDivChilds(childCount == 0 ? 1 : childCount)
    })

    useEffect(() => {
        function ensureSingleChild(div, newChild) {

            // If the div has more than one child, remove all but the last one
            while (div?.children?.length > 1) {
                div.removeChild(div?.firstElementChild)
            }
            // If the div has no children, simply append the new child
            if (div?.children?.length === 0) {
                div?.appendChild(newChild)
            } else {
                // Otherwise, replace the current child with the new child
                div?.replaceChild(newChild, div.firstElementChild)
            }
        }
        const restrictedDiv = document.getElementById('token-iframe')
        // Example: Adding new content
        const newElement = document.createElement('p')
        // newElement.textContent = 'This is the new single child content.'
        // Call the function to ensure there's only one child in the div
        ensureSingleChild(restrictedDiv, newElement)
        return () => {
        }

    }, [EMPTY_ARRAY, divChilds])

    useEffect(() => {
        // console.log(faciltyData?.facility_payment_details?.datacap_ecommerce_token, 'I am here 1')
        if (
            divChilds == 1
        ) {
            try {
                new Promise(() => window.DatacapHostedWebToken.init(
                    faciltyData?.facility_payment_details?.datacap_ecommerce_token, 'token-iframe', getToken()
                ))
            } catch (error) {
                setGatewayError(errorMessage?.somethingWentWrong)
            }
        }
    }, [EMPTY_ARRAY, faciltyData, divChilds])

    const getToken = () => {
        onIFrameLoaded()
        const tokenCallback = (tokenResponse) => {
            return new Promise(function () {
                // setIsSubmittingForm(false)
                if (tokenResponse.Error) {
                    setGatewayError(tokenResponse.Error)
                    return
                }
                var token = tokenResponse.Token
                if (token != '' && token != undefined) {
                    if(page == 'reservation') {
                        // setFormData({ ...formData, 'paymentToken': token })
                        setValue('paymentToken', tokenResponse)
                        if(APILoad?.current == true) {
                            APILoad.current = false
                            onSubmit()
                        }
                    } else if(page == 'permit') {
                        if(APILoad?.current == true) {
                            APILoad.current = false
                            setFormData({ ...formData, 'paymentToken': tokenResponse })
                            onSubmit({ ...formData, 'paymentToken': tokenResponse })
                        }
                    } else if (page == 'permitRequest') {
                        if(APILoad?.current == true) {
                            APILoad.current = false
                            setFormData({ ...formData, 'paymentToken': tokenResponse })
                            onSubmit({ ...formData, 'paymentToken': tokenResponse })
                        }
                    } else if(page == 'addCard') {
                        if(APILoad?.current == true) {
                            APILoad.current = false
                            onSubmit(tokenResponse)
                        }
                    } else {
                        setFormData({ ...formData, 'paymentToken': tokenResponse })
                        onSubmit({ ...formData, 'paymentToken': tokenResponse })
                    }
                    setGatewayError('')
                } else {
                    setGatewayError(errorMessage?.somethingWentWrong)
                }
            }).catch((err) => {
                // setIsSubmittingForm(false)
                setGatewayError(err ? err : errorMessage?.somethingWentWrong)
            })
        }
        return tokenCallback
    }

    let IFrameWindow
    let intervalId

    const onIFrameLoaded = () => {
        const originalOpen = window.open
        window.open = function (url, name, specs) {
            const newWindow = originalOpen(url, name, specs)
            IFrameWindow = newWindow
            // Call API for Storing Logs
            monitorWindowClosed()
            return newWindow
        }
    }

    const monitorWindowClosed = () => {
        intervalId = setInterval(() => {
            if (IFrameWindow && IFrameWindow.closed) {
                // Call API for Storing Logs
                clearInterval(intervalId)
            }
        }, 500)
    }

    document.addEventListener('DOMContentLoaded', () => {
        // Ensure onIFrameLoaded is called after the Google Pay script is loaded
    })

    return (<>
            <div>
                <div className="card-body">
                    <iframe id="token-iframe" frameBorder="0" width={'100%'} height={'225px'}></iframe>
                    <input type="hidden" id="token" />
                    {gatewayError && <div style={{ color: 'red', fontSize: '14px' }}>{gatewayError}</div>}
                    {consent}
                    
                    <div id='q-box__buttons' className='text-center mt-4 d-flex gap-1 justify-content-center'>
                        {previousButton}
                        <button
                            type="button"
                            name="submit"
                            className={(page== 'reservation' || page == 'addCard') ? 'btn btn-primary d-flex step-btn w-100' : 'btn btn-primary d-flex step-btn w-100'}
                            style={{ opacity: (isSubmittingForm ? true : false) ? '0.8' : '1' }}
                            onClick={(event) => {
                                event.stopPropagation()
                                event.preventDefault()
                                window.DatacapHostedWebToken.requestToken()
                            }}
                            disabled={(isSubmittingForm) ? true : false}
                        >
                            <div className='d-flex justify-content-center align-items-center'>
                                <span className='mb-0'>{page == 'addCard' ? 'Save Card' : page== 'reservation' ? 'Confirm & Book' : 'Submit'}</span>{isSubmittingForm ? <span className='ms-2'>
                                    <Circles
                                        height="20"
                                        width="20"
                                        style={{ display: 'inline-block' }}
                                        color="#ffffff"
                                        ariaLabel="circles-loading"
                                        visible={true}
                                    />
                                </span> : null}
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

PGIframeDC.propTypes = {
    dispatch: PropTypes.func,
    onSubmit: PropTypes.func,
    isSubmittingForm: PropTypes.bool,
    setIsSubmittingForm: PropTypes.func,
    getValues: PropTypes.func,
    faciltyData: PropTypes.object,
    consent: PropTypes.elementType,
    setValue: PropTypes.func,
    previousButton: PropTypes.elementType,
    page: PropTypes.string,
    formData: PropTypes.object,
    setFormData: PropTypes.func,
    APILoad: PropTypes.oneOfType([
        PropTypes.func, 
        PropTypes.shape({ current: PropTypes.any })
    ])
}

PGIframeDC.defaulProps = {
    dispatch: noop,
    onSubmit: noop,
    isSubmittingForm: false,
    setIsSubmittingForm: noop,
    getValues: noop,
    faciltyData: EMPTY_OBJECT,
    consent: DefaultComponent,
    setValue: noop,
    previousButton: DefaultComponent,
    page: '',
    formData: EMPTY_OBJECT,
    setFormData: noop,
    APILoad: null
}

function mapStateToProps() {
    return {
    }
}
export default connect(mapStateToProps)(PGIframeDC)